import './Logo.scss';
import logo from './img/logo.png';

const Logo = () => {
  return <img src={logo} className="logo" alt="Health &amp; Her Logo" />;
};

export default Logo;
